import { render } from "./curriculumDetails.vue?vue&type=template&id=2d0d35f8"
import script from "./curriculumDetails.vue?vue&type=script&lang=js"
export * from "./curriculumDetails.vue?vue&type=script&lang=js"

import "./curriculumDetails.vue?vue&type=style&index=0&id=2d0d35f8&lang=less"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__